import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import GlassCard from "./GlassCard";

export default function Job(props) {
  const isMobile = useMediaQuery("(max-width: 700px)");

  return (
    <GlassCard
      sx={{
        mb: 1,
        padding: "16px 20px",

        "&:hover": {
          border: "1px solid rgba(255,131,168,0.85)",
          boxShadow: "0 8px 36px rgba(0,0.85)",
        },
        transition: "border 0.25s, box-shadow 0.25s",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>
          {props.company ? (
            <Typography
              component="div"
              variant={isMobile ? "subtitle1" : "h6"}
              color="primary"
              sx={{
                fontFamily: "Roboto",
                fontWeight: isMobile ? 600 : 500,
              }}
            >
              <Box component="span" sx={{ color: "#FF83A8", fontWeight: 600 }}>
                {props.company}
              </Box>
              {" | "}
              {props.position}
            </Typography>
          ) : props.task ? (
            <Typography
              component="div"
              variant={isMobile ? "subtitle1" : "h6"}
              color="primary"
              sx={{
                fontFamily: "RobotoLight",
                fontWeight: 300,
                fontStyle: "italic",
                opacity: 0.7,
              }}
            >
              {props.task}
            </Typography>
          ) : null}
        </Box>
        <Box sx={{ mt: 0.25 }}>
          <Typography
            component="div"
            variant="body2"
            sx={{
              fontFamily: "RobotoLight",
              fontWeight: 300,
              color: "rgba(255,255,255,0.85)",
              fontSize: "0.78rem",
            }}
          >
            {props.dateS}
            {props.dateE ? " – " + props.dateE : null}
            {props.location ? " · " + props.location : null}
          </Typography>
        </Box>
        {props.desc ? (
          <Box sx={{ mt: 1 }}>
            <Typography
              component="div"
              variant="body2"
              sx={{
                fontFamily: "RobotoLight",
                fontWeight: 300,
                color: "rgba(255,255,255,0.85)",
                lineHeight: 1.7,
              }}
            >
              {props.desc}
            </Typography>
          </Box>
        ) : null}
      </Box>
    </GlassCard>
  );
}
